import {
  useCrarCodigosPokemon,
  useListarCuponesPokemones,
  useListarPokemones,
  useSelectPokemon
} from "../../../../Hooks/Admin";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import {
  camposFormulario,
  columns,
  formatData,
  camposFilter,
} from "./camposFormulario";
import { useEffect, useState } from "react";


export const PokemonesCodigos = () => {
  const [campos, setCampos] = useState();
  const queryListarPokemones = useListarPokemones([]);
  const querySelectPokemon = useSelectPokemon();

  useEffect(() => {
    if (queryListarPokemones.isSuccess) {
      setCampos(camposFormulario(queryListarPokemones.data));
    }
  }, [queryListarPokemones.isSuccess]);
  return (
    <>
      {campos && (
        <CustomTable
            tituloTabla="Codigos Pokemon"

          camposFilter={camposFilter}
          camposFormularioModal={campos}
          queryListar={useListarCuponesPokemones}
          formatData={formatData}
          columns={columns}
          
          camposAgregar={camposFormulario(querySelectPokemon.data)}
          queryCrear={useCrarCodigosPokemon}
        />
      )}
    </>
  );
};
